import React from "react";
import { Table } from "@shared/components/Table";

export const tableMapper = (
  props: React.DetailedHTMLProps<
    React.TableHTMLAttributes<HTMLTableElement>,
    HTMLTableElement
  >
) => {
  return <Table {...props} />;
};
